/* =====================================================================
 * Familie-Namen-Poster Editor (PROJ-49)
 * =====================================================================
 * Reines Text-Poster (KEIN Foto, KEIN Crop, KEINE Map). Kopiervorlage
 * = jahreszahlen.js / zuhause.js (State/Live-Preview, Namen-Add-Rows,
 * Ausrichtungs-Toggle, Groessen-/Frame-Picker aus target_product.variants,
 * Cart-Add). Imageless-Typo-Familie (blanket/letterposter).
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderFamilie() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1 (gleiche Positionen,
 * cqw/em-Groessen, Fit-Formeln). Aendert sich der Server, muss dieser
 * Block mitgezogen werden - Werte bewusst identisch.
 *
 * Layout: grosses, blasses Serif-Wort (Default "FAMILIE", z-index 1) mittig;
 * darueber (z-index 3) EINE Zeile Vornamen in Script, durch kleine Herzen
 * getrennt, mit einer kurzen Linie am Anfang und Ende. Ausrichtung
 * Quer-/Hochformat (Toggle dreht nur print.width/height, gleiche SKU).
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.FM_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var SERIF = "'Playfair Display', Georgia, serif";
  var SCRIPT = "'Great Vibes', cursive";
  var SANS = "'Outfit', system-ui, sans-serif";
  var HEART = 'M 49.4 0 C 27 0, 0 24, 0 60 C 0 105, 58 166, 110 200 C 162 166, 220 105, 220 60 C 220 24, 193 0, 170.6 0 C 152 1, 116 16, 110 58 C 104 16, 68 1, 49.4 0 Z';
  var MAX_NAMES = 8, MIN_NAMES = 2;

  /* ---- Modul-State (eine Section pro -gestalten-Page) ---- */
  var root, stage, sectionId, autocomplete;
  var state = {
    layout: 'namen',         // 'namen' (Vornamen im Wort) | 'home' (Familienname + Fusszeile + Ort)
    bg_word: 'FAMILIE',
    family_name: 'Familie Berg',
    city: 'Leipzig',
    coords: 'N 50° 56′ 12.0″   E 6° 55′ 30.0″',
    word_color: '#dad5cc',   // Hellgrau = Default (blasses Hintergrund-Wort)
    c_names: '#28292d',      // Script-Namen + Herzen + Linien
    orientation: 'landscape',
    bg_color: '#ffffff',
    paper_size: '30x40',
    variant_id: '',
    product_type: '',
    frame_color: 'brown'
  };

  /* Dezimal -> DMS (1:1 aus zuhause.js - Rundungs-Uebertrag 60->0 sauber) */
  function toDMS(dec, isLat) {
    var hemi = isLat ? (dec < 0 ? 'S' : 'N') : (dec < 0 ? 'W' : 'E');
    var a = Math.abs(dec);
    var deg = Math.floor(a);
    var minFloat = (a - deg) * 60;
    var min = Math.floor(minFloat);
    var sec = Math.round((minFloat - min) * 60 * 10) / 10;
    if (sec >= 60) { sec = 0; min += 1; }
    if (min >= 60) { min = 0; deg += 1; }
    return hemi + ' ' + deg + '° ' + min + '′ ' + sec.toFixed(1) + '″';
  }
  function coordsFromLatLng(lat, lng) {
    return toDMS(lat, true) + '   ' + toDMS(lng, false);
  }

  /* Home-Layout: Wort ab 4 Zeichen deterministisch in 2 ausgewogene Zeilen
   * (HOME -> HO/ME). Gleiche Formel im Server (renderFamilie) - Print-Match! */
  function splitWord(word) {
    var w = word.replace(/\s+/g, '');
    if (w.length < 4) return [word];
    var cut = Math.ceil(w.length / 2);
    return [w.slice(0, cut), w.slice(cut)];
  }

  /* Namen aus dem DOM lesen (Markup = Source of Truth, Playbook §1) */
  function readNames() {
    var rows = [];
    root.querySelectorAll('#fm-names .fm-name-row').forEach(function (r) {
      rows.push({ name: (r.querySelector('.fm-name').value || '').trim(), el: r });
    });
    return rows;
  }
  function completeNames() {
    return readNames().filter(function (n) { return n.name; }).map(function (n) { return n.name; });
  }

  /* ===================================================================
   * Render-Bausteine - 1:1-Spiegel des Servers (print-mode.js)
   * =================================================================== */
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function flourSpan(col) {
    return '<span style="display:inline-flex;align-items:center;width:1.6em;flex:0 0 auto;">' +
      '<svg viewBox="0 0 44 8" style="width:100%;height:auto;overflow:visible;">' +
      '<path d="M2 4 H42" stroke="' + col + '" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg></span>';
  }
  function heartSpan(col) {
    return '<span style="display:inline-flex;align-items:center;width:0.6em;flex:0 0 auto;">' +
      '<svg viewBox="0 0 220 200" style="width:100%;height:auto;">' +
      '<path d="' + HEART + '" fill="' + col + '"/></svg></span>';
  }
  function nameSizeFor(n) { return Math.min(7.5, 30 / Math.max(1, n)); }

  function fmFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 60) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  /* ===================================================================
   * Live-Render - 1:1-Spiegel von renderFamilie() (Server)
   * =================================================================== */
  function renderLayoutNamen(grid) {
    var col = state.c_names || INK;
    var names = completeNames();

    // ---- Hintergrund-Wort (gross, blass, Serif, z-index 1) ----
    var word = (state.bg_word || 'FAMILIE').trim();
    var elWord = document.createElement('div');
    elWord.className = 'text-slot';
    elWord.textContent = word;
    elWord.style.cssText = 'position:absolute;z-index:1;left:50%;top:50%;transform:translate(-50%,-50%);' +
      'font-family:' + SERIF + ';font-weight:600;font-size:22cqw;' +
      'color:' + state.word_color + ';text-transform:uppercase;letter-spacing:0.06em;' +
      'white-space:nowrap;line-height:1;';
    grid.appendChild(elWord);

    // ---- Namen-Zeile (Script + Herzen + End-Linien, z-index 3) ----
    var line = document.createElement('div');
    line.style.cssText = 'position:absolute;z-index:3;left:50%;top:50%;transform:translate(-50%,-50%);' +
      'display:flex;align-items:center;justify-content:center;white-space:nowrap;' +
      'font-family:' + SCRIPT + ';font-weight:400;color:' + col + ';' +
      'font-size:' + nameSizeFor(names.length) + 'cqw;gap:0.42em;line-height:1;';
    var parts = [flourSpan(col)];
    names.forEach(function (nm, i) {
      if (i > 0) parts.push(heartSpan(col));
      parts.push('<span style="flex:0 0 auto;">' + esc(nm.toLowerCase()) + '</span>');
    });
    parts.push(flourSpan(col));
    line.innerHTML = parts.join('');
    grid.appendChild(line);

    return function fit() { fmFit(elWord, 92); fmFit(line, 86); };
  }

  function renderLayoutHome(grid) {
    var col = state.c_names || INK;
    var names = completeNames();

    // ---- Hintergrund-Wort, ggf. 2-zeilig (HO/ME), leicht oberhalb der Mitte ----
    var lines = splitWord('HOME');  // Wort ist beim Home-Design FIX (Dominik 18.07.)
    var elWord = document.createElement('div');
    elWord.className = 'text-slot';
    elWord.innerHTML = lines.map(esc).join('<br>');
    elWord.style.cssText = 'position:absolute;z-index:1;left:50%;top:44%;transform:translate(-50%,-50%);' +
      'font-family:' + SERIF + ';font-weight:600;font-size:' + (lines.length > 1 ? 50 : 30) + 'cqw;' +
      'color:' + state.word_color + ';text-transform:uppercase;letter-spacing:0.04em;' +
      'white-space:nowrap;line-height:0.82;text-align:center;';
    grid.appendChild(elWord);

    // ---- Familienname (Script, quer ueber der Wortmitte, z-index 3) ----
    var fam = document.createElement('div');
    fam.className = 'text-slot';
    fam.textContent = (state.family_name || '').trim();
    fam.style.cssText = 'position:absolute;z-index:3;left:50%;top:44%;transform:translate(-50%,-50%);' +
      "font-family:'parlare', cursive;" + 'font-weight:400;font-size:9cqw;color:' + col + ';' +
      'white-space:nowrap;line-height:1;';
    grid.appendChild(fam);

    // ---- Fusszeile: Vornamen (Caps) + Linie + Ort mit Koordinaten ----
    var kids = document.createElement('div');
    kids.className = 'text-slot';
    kids.textContent = names.map(function (n) { return n.toUpperCase(); }).join('   ·   ');
    kids.style.cssText = 'position:absolute;z-index:3;left:50%;top:86%;transform:translate(-50%,-50%);' +
      'font-family:' + SANS + ';font-weight:500;font-size:2.4cqw;letter-spacing:0.28em;' +
      'color:' + col + ';white-space:nowrap;line-height:1;';
    grid.appendChild(kids);

    var rule = document.createElement('div');
    rule.style.cssText = 'position:absolute;z-index:3;left:50%;top:88.6%;transform:translate(-50%,-50%);' +
      'width:56cqw;height:1px;background:' + col + ';opacity:0.65;';
    grid.appendChild(rule);

    var ortText = [(state.city || '').trim(), (state.coords || '').trim()].filter(Boolean).join('   ');
    var ort = document.createElement('div');
    ort.className = 'text-slot';
    ort.textContent = ortText;
    ort.style.cssText = 'position:absolute;z-index:3;left:50%;top:91%;transform:translate(-50%,-50%);' +
      'font-family:' + SANS + ';font-weight:400;font-size:1.9cqw;letter-spacing:0.14em;' +
      'color:' + col + ';white-space:nowrap;line-height:1;';
    grid.appendChild(ort);

    return function fit() { fmFit(elWord, 88); fmFit(fam, 86); fmFit(kids, 80); fmFit(ort, 74); };
  }

  function render() {
    if (!stage) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;

    var fit = (state.layout === 'home') ? renderLayoutHome(grid) : renderLayoutNamen(grid);

    stage.innerHTML = '';
    stage.appendChild(grid);
    fit();
  }

  /* ===================================================================
   * Namen-Zeilen-Editor: + Name (max 8), Entfernen (min 2)
   * =================================================================== */
  function updateNameControls() {
    var rows = root.querySelectorAll('#fm-names .fm-name-row');
    var addBtn = document.getElementById('fm-add-name');
    if (addBtn) addBtn.style.display = rows.length >= MAX_NAMES ? 'none' : '';
    rows.forEach(function (r) {
      var rm = r.querySelector('.fm-remove');
      if (rm) rm.style.visibility = rows.length <= MIN_NAMES ? 'hidden' : 'visible';
    });
  }
  function addNameRow() {
    var container = document.getElementById('fm-names');
    if (!container || container.querySelectorAll('.fm-name-row').length >= MAX_NAMES) return;
    var row = document.createElement('div');
    row.className = 'fm-name-row';
    row.innerHTML = '<input type="text" class="fm-name" maxlength="18" autocomplete="off" placeholder="Vorname">' +
      '<button type="button" class="fm-remove" aria-label="Zeile entfernen">&times;</button>';
    container.appendChild(row);
    updateNameControls();
    row.querySelector('.fm-name').focus();
  }
  function initNamesEditor() {
    var container = document.getElementById('fm-names');
    if (!container) return;
    container.addEventListener('input', function () { render(); });
    container.addEventListener('click', function (e) {
      var rm = e.target.closest('.fm-remove');
      if (!rm) return;
      e.preventDefault();
      if (container.querySelectorAll('.fm-name-row').length <= MIN_NAMES) return;
      rm.closest('.fm-name-row').remove();
      updateNameControls();
      render();
    });
    var addBtn = document.getElementById('fm-add-name');
    if (addBtn) addBtn.addEventListener('click', function (e) { e.preventDefault(); addNameRow(); render(); });
    updateNameControls();
  }

  /* ===================================================================
   * Eingaben: Hintergrund-Wort, Farben
   * =================================================================== */
  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
  }
  function initColorPickers() {
    root.querySelectorAll('.fm-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
      p.addEventListener('input', function () { state[p.dataset.key] = p.value; render(); });
    });
  }
  function initPresetSwatches() {
    var swatches = root.querySelectorAll('.fm-preset[data-color]');
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) {
        e.preventDefault();
        swatches.forEach(function (x) { x.classList.remove('current'); });
        s.classList.add('current');
        state.word_color = s.getAttribute('data-color');
        render();
      });
    });
    var active = root.querySelector('.fm-preset.current[data-color]');
    if (active) state.word_color = active.getAttribute('data-color');
  }
  function initPaperColor() {
    var swatches = root.querySelectorAll('.fm-paper[data-color]');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
  }

  /* ===================================================================
   * Layout-Umschalter (Namen im Wort vs. Home) + Home-Felder-Sichtbarkeit
   * =================================================================== */
  function setLayout(layout) {
    state.layout = layout === 'home' ? 'home' : 'namen';
    root.querySelectorAll('.fm-layout-btn').forEach(function (b) {
      b.classList.toggle('current', b.getAttribute('data-layout') === state.layout);
    });
    root.querySelectorAll('.fm-home-only').forEach(function (el) {
      el.style.display = state.layout === 'home' ? '' : 'none';
    });
    render();
  }
  function initLayoutPicker() {
    root.querySelectorAll('.fm-layout-btn').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); setLayout(b.getAttribute('data-layout')); });
    });
    setLayout(root.dataset.defaultLayout || 'namen');
  }

  /* Ort-Suche (Home-Layout) - Google Places, 1:1 zuhause-Muster (Retry bis API da).
   * Treffer -> Ortsname + DMS-Koordinaten; beide Felder bleiben manuell editierbar. */
  function initAutocomplete() {
    if (autocomplete) return;
    var search = document.getElementById('fm-ort-search');
    if (!search) return;
    if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
      setTimeout(initAutocomplete, 250);
      return;
    }
    autocomplete = new google.maps.places.Autocomplete(search, {
      fields: ['geometry', 'address_components', 'name'],
      types: ['geocode']
    });
    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place || !place.geometry) return;
      state.coords = coordsFromLatLng(place.geometry.location.lat(), place.geometry.location.lng());
      var coordsInput = document.getElementById('fm-coords');
      if (coordsInput) coordsInput.value = state.coords;
      var locality = (place.address_components || []).find(function (c) { return c.types.indexOf('locality') !== -1; });
      var cityName = locality ? locality.long_name : (place.name || '');
      if (cityName) {
        state.city = cityName;
        var cityInput = document.getElementById('fm-city');
        if (cityInput) cityInput.value = cityName;
      }
      render();
    });
  }

  /* Info-Gluehbirne (Stadt-/Sternkarten-Muster, .tab-help) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  /* Tabs (Design / Produkt) - main__switcher-Konvention (editor-tabs.css) */
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - Geburtsposter-Schema, orientierungs-treu (zuhause-Muster)
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function effectiveDim() {
    var d = parsePosterDim(state.paper_size);
    var lo = Math.max(d.w, d.h), sh = Math.min(d.w, d.h);
    return state.orientation === 'landscape' ? { w: lo, h: sh } : { w: sh, h: lo };
  }
  function formatPrice(cents) { return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ','); }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = effectiveDim();
    stage.style.setProperty('--collage-aspect', d.w + ' / ' + d.h);
    var flat = stage.closest('.fm-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (d.w / d.h) + ')';
    render();
  }
  function initOrientationPicker() {
    var buttons = root.querySelectorAll('.orientation-picker li a');
    if (!buttons.length) return;
    var current = root.querySelector('.orientation-picker li a.current');
    if (current) state.orientation = current.dataset.orientation || 'landscape';
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        buttons.forEach(function (b) { b.classList.remove('current'); });
        btn.classList.add('current');
        state.orientation = btn.dataset.orientation || 'landscape';
        syncStageToSize();
      });
    });
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('fm-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }
  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Muster jahreszahlen.js: Render-Job synchron anstossen,
   * dann /cart/add.js mit _print_image_url + Config-Properties.
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('fm-cart-btn-' + sectionId);
    var names = completeNames();
    if (names.length < MIN_NAMES) { alert('Bitte trage mindestens 2 Namen ein.'); return; }
    if (state.layout !== 'home' && !(state.bg_word || '').trim()) { alert('Bitte gib das Hintergrund-Wort ein (z.B. FAMILIE).'); return; }
    if (state.layout === 'home' && !(state.family_name || '').trim()) { alert('Bitte gib den Familiennamen ein (z.B. Familie Schneider).'); return; }
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var d = effectiveDim();

        var payload = {
          product: 'familie',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: d.w, height: d.h, dpi: 300 },
          orientation: state.orientation,
          bg_color: state.bg_color,
          layout: state.layout,
          bg_word: state.layout === 'home' ? 'HOME' : (state.bg_word || 'FAMILIE').trim(),
          family_name: state.layout === 'home' ? (state.family_name || '').trim() : '',
          city: state.layout === 'home' ? (state.city || '').trim() : '',
          coords: state.layout === 'home' ? (state.coords || '').trim() : '',
          names: names,
          word_color: state.word_color,
          c_names: state.c_names || INK
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/familie/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/familie/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend nicht erreichbar -> Fallback-URL bleibt */ }

        /* Alle Properties versteckt (_-Prefix) - Warenkorb zeigt nur Produkt + Preis */
        var props = {
          '_Namen': names.join(', '),
          '_Wort': (state.bg_word || 'FAMILIE').trim(),
          '_Layout': state.layout === 'home' ? 'Home' : 'Namen im Wort',
          '_Familienname': state.layout === 'home' ? (state.family_name || '').trim() : '',
          '_Ort': state.layout === 'home' ? [(state.city || '').trim(), (state.coords || '').trim()].filter(Boolean).join('  ') : '',
          '_Ausrichtung': state.orientation === 'landscape' ? 'Querformat' : 'Hochformat',
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': state.paper_size,
          '_produkt': 'familie'
        };
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[familie] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init - Input-Values aus dem Markup sind Source of Truth (Playbook §1)
   * =================================================================== */
  function init() {
    root = document.querySelector('.fm-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('fm-stage-' + sectionId);

    bindField('fm-word', 'bg_word');
    bindField('fm-family', 'family_name');
    bindField('fm-city', 'city');
    bindField('fm-coords', 'coords');
    initNamesEditor();
    initColorPickers();
    initPresetSwatches();
    initPaperColor();
    initOrientationPicker();
    initLayoutPicker();
    initAutocomplete();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('fm-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
